export enum ProductCardVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
